import React from 'react';

import StorePresenter from '../../../../../../../presenters/StorePresenter';
import appRoutes from '../../../../../../../routes/appRoutes';

const FastCash = (props) => {
  const { brand } = props;
  const storeId = StorePresenter.id(brand);

  return (
    <div>
      <div className="brand-field">
        <h4>FastCash</h4>
        <div>
          <a
            className="action-button -in-group"
            target="_blank"
            href={appRoutes.cashbackRatesPath(storeId)}
          >
            Cashback Rates
          </a>
          <a
            className="action-button -in-group"
            target="_blank"
            href={appRoutes.invoicesPath(storeId)}
          >
            Invoices
          </a>
        </div>
      </div>
    </div>
  );
};

export default FastCash;
